    export enum HiddenFlag
    {
        HiddenCapacity = 1 << 0,
        HiddenSkills = 1 << 1,
        HiddenShopfloor = 1 << 2
    }